<div
    ng-form="fieldRecordAttachmentsForm"
    class="well">
    <h5>Attachments</h5>

    <table class="table table-hover table-striped">
        <thead>
            <tr class="default">
                <th>&nbsp;</th>
                <th class="text-nowrap">Type</th>
                <th class="text-nowrap">File</th>
                <th class="text-nowrap">Details</th>
                <th class="text-nowrap">Status</th>
                <th>&nbsp;</th>
            </tr>
        </thead>
        <tbody>
            @for (attachment of model.attachments; track attachment; let i = $index) {
                <tr>
                    <td>&nbsp;</td>
                    <td class="text-nowrap">
                        <div
                            [value]="getAttachmentType(attachment.type)"
                            [ngClass]="{'required-input': attachment.status == 'Mandatory'}"
                            ng-class="{'required-input': attachment.status == 'Mandatory'}"
                            >{{getAttachmentType(attachment.type)}}</div
                        >
                    </td>
                    <td class="text-nowrap">
                        <div ng-bind="attachment.fileName">{{attachment.fileName}}</div>
                        @if (!attachment.fileName) {
                            <input
                                type="hidden"
                                name="fileName{{$index}}"
                                [(ngModel)]="model.fileName"
                                #fileName="ngModel"
                                [required]="attachment.status === 'Mandatory'" />
                        }
                    </td>
                    <td
                        class="text-nowrap"
                        [ngClass]="{'has-error': !isFileNameValid(i) && submitted}"
                        ng-class="{'has-error': fieldRecordAttachmentsForm['fileName' + $index].$invalid
                && (fieldRecordAttachmentsForm['fileName' + $index].$dirty || fieldRecordAttachmentsForm.$submitted)}">
                        <div class="input-group">
                            <span class="input-group-addon corner">
                                <i
                                    class="nlrp-icon nlrp-icon-edit nlrp-18 corner-icon disabled"
                                    [ngClass]="{disabled: !attachment.fileName}"
                                    ng-class="{disabled: !attachment.fileName}"></i>
                            </span>
                            <textarea
                                class="form-control"
                                name="details"
                                id="details"
                                placeholder="Details"
                                rows="2"
                                cols="40"
                                [disabled]="!attachment.fileName"
                                [(ngModel)]="attachment.details"
                                maxlength="255"></textarea>
                        </div>
                    </td>
                    <td class="text-nowrap">
                        <div ng-bind="attachment.status">{{attachment.status}}</div>
                    </td>
                    <td class="text-nowrap">
                        @if (!attachment.fileName) {
                            <i
                                (click)="attach(i)"
                                ng-if="!attachment.fileName"
                                ng-click="$ctrl.attach($index)"
                                class="nlrp-icon nlrp-icon-paper-clip"
                                id="attachFile"
                                title="Click to attach a file"
                                tabindex="0"></i>
                        }
                        @if (attachment.fileName) {
                            <i
                                (click)="view(i)"
                                class="nlrp-icon nlrp-icon-view-attachment"
                                id="viewAttachment"
                                title="View attachment"
                                tabindex="0"></i>
                        }
                        @if (attachment.fileName) {
                            <i
                                (click)="clear(i)"
                                class="nlrp-icon nlrp-icon-trash"
                                id="clear"
                                title="Clear"
                                tabindex="0"></i>
                        }
                    </td>
                </tr>
            }
        </tbody>
    </table>
    @if (modalIsOpen) {
        <nlr-field-record-attachments-modal (modalCloseEvent)="dismissModal()"></nlr-field-record-attachments-modal>
    }
</div>
